
    <table datatable class="mb-0 table align-middle effects-table"
        [ngClass]="{'hidden': (showBotBuilder || showDeterminantBuilder || showBotEdit)}">
        <thead *ngIf="showTableheader">
            <tr>
                <th class="text-center cell-order">&nbsp;</th>
                <th>{{'Determinant' | translate}}</th>
                <th>{{'Action' | translate}}</th>
                <th class="text-center cell-delete">&nbsp;</th>
            </tr>
            <tr class="separator-header"><th colspan="4"></th></tr>
        </thead>
        <tbody
            cdkDropList
            [cdkDropListData]="componentAction.actions"
            (cdkDropListDropped)="dropped($event)">
            <tr cdkDrag *ngFor="let action of componentAction.actions; let i=index;" class="bots-loop bot-{{ action.bots.length ? action.bots[0].botType : ''}}">
                <td class="text-center align-middle handlers-cell">
                    <i cdkDragHandle class="fa-solid fa-grip-dots handle mx-1" style="font-size:0.8rem"></i>
                </td>
                <td>
                    <div (click)="openDeterminantModal(action)">
                        <determinant-query-readonly *ngIf="!isDeterminantEmpty(action.jsonDeterminants)"
                                                    [jsonDeterminants]="action.jsonDeterminants"
                                                    [determinantMapById]="determinantMapById"
                        ></determinant-query-readonly>
                        <div class="workarea__draghere" *ngIf="isDeterminantEmpty(action.jsonDeterminants)">
                            <div class="editBtn light text-dark">{{'Select' | translate}}</div>
                        </div>
                    </div>
                </td>
                <td *ngIf="!isBotEmpty(action.bots)">
                    <div class="d-flex align-items-center" *ngFor="let bot of action.bots; let j=index;">
                        <span class="d-flex flex-shrink-1 mr-2 item-and-or" *ngIf="j > 0"> + </span>
                        <div *ngIf="!isBotEmpty(action.bots)" class="editBtn light text-dark">
                            <span (click)="openBotBuilder(action)">
                                {{ bot.name }} - 
                                <b *ngIf="bot.botType === 'document'">{{'bots.documentBot' | translate}}</b>
                                <b *ngIf="bot.botType === 'system'">{{'bots.systemBot' | translate}}</b>
                                <b *ngIf="bot.botType === 'data'">{{'bots.dataBot' | translate}}</b>
                                <b *ngIf="bot.botType === 'internal'">{{'bots.internalBot' | translate}}</b>
                                <b *ngIf="bot.botType === 'message'">{{'bots.messageBot' | translate}}</b>
                            </span>
                            <i *ngIf="bot.botType !== 'system'" (click)="directEditBot(bot);" tooltip="{{'Bot mapping' | translate}}" class="fal fa-exchange ml-2"></i>
                        </div>
                        <div class="editBtn light text-dark p-0 ml-2" *ngIf="bot.botType !== 'system'">
                            <span class="multiple-bot mr-2 ml-auto" placement="left" tooltip="{{'Is bot multiple' | translate}}" (click)="toggleMultipleRole(action)">
                                <i class="ml-2 fas {{action?.multipleBot ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"></i>
                            </span>
                            <i *ngIf="action.multipleBot"
                                class="fal fa-th mr-2"
                                style="vertical-align: top; margin-top: 5px;"
                                [popover]="fieldsPopover"
                                placement="left"
                                popoverTitle="{{ 'Select field' | translate }}"
                                containerClass="confirmation-popover"
                                triggers="click"
                                #pop="bs-popover"
                                [outsideClick]="true"></i>
                            <ng-template #fieldsPopover>
                                <div class="popover-buttons">
                                    <select class="form-control" [(ngModel)]="action.multipleFieldKey" (change)="saveActionComponent();">
                                        <option *ngFor="let field of gridFields" value="{{field.fullKey}}">{{formatFieldName(field.fullName || field.name)}}</option>
                                    </select>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </td>
                <td *ngIf="isBotEmpty(action.bots)">
                    <div class="workarea__draghere" (click)="openBotBuilder(action)">
                        <div class="editBtn light text-dark">{{'Click to add bot' | translate}}</div>
                    </div>
                </td>
                <td class="text-center opts-cell">
                    <div class="d-flex align-items-center justify-content-end">
                        <!--
                        <span *ngIf="showSystemBots" class="parallel-bot mr-2" placement="left" tooltip="{{'Parallel to previous if checked' | translate}}" (click)="toggleParallelRole(action)">
                            <i class="ml-2 fas {{action?.parallel ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}" style="position:relative;top:2px;inset-inline-start:-4px;"></i>
                        </span>
                        <span class="parallel-bot mr-2" placement="left" tooltip="{{'Mandatory - will be passed even if previous rows failed' | translate}}" (click)="toggleMandatoryRole(action)">
                            <i class="ml-2 fas {{action?.mandatory ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}" style="position:relative;top:2px;inset-inline-start:-4px;"></i>
                        </span>
                        -->
                        <div class="editBtn light text-dark p-0 ml-auto" *ngIf="i > 0">
                            <span *ngIf="showSystemBots" class="parallel-bot ml-1" placement="left" tooltip="{{'Parallel to previous if checked' | translate}}" (click)="toggleParallelRole(action)">
                                <i class="ml-2 fas {{action?.parallel ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}" style="position:relative;inset-inline-start:-4px;"></i>
                            </span>
                            <span class="parallel-bot mr-2" placement="left" tooltip="{{'Mandatory - will be passed even if previous rows failed' | translate}}" (click)="toggleMandatoryRole(action)">
                                <i class="ml-2 fas {{action?.mandatory ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}" style="position:relative;"></i>
                            </span>
                        </div>
                        <i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon false mx-2" (click)="removeActionRow(i)"></i>
                    </div>
                </td>
            </tr>
            <tr class="separator-row" *ngIf="componentAction?.actions?.length"><td colspan="4"></td></tr>
            <tr class="placeholder-row">
                <td></td>
                <td>
                    <div (click)="openDeterminantModal(null); isNew = true;">
                        <div class="workarea__draghere">
                            <div class="editBtn light text-dark">{{'Select' | translate}}</div>
                        </div>
                    </div>
                </td>
                <td>
                    <div (click)="openBotBuilder(null); isNew = true;">
                        <div class="workarea__draghere">
                            <div class="editBtn light text-dark">{{'Click to add bot' | translate}}</div>
                        </div>
                    </div>
                </td>
                <td class="text-right"></td>
            </tr>
        </tbody>
    </table>

    <drawer [title]="'Apply determinant'"
        [showHeader]="showDrawerHeader"
        [isClosed]="!showDeterminantBuilder"
        [noContentPadding]="!embedded"
        (saveEvent)="updateDeterminant($event)"
        [embedded]="embedded" (closeEvent)="closeLayer();"
        [contextLabel]="contextLabel"
        class="text-left in-modal-drawer">
        <div class="drawer-content drawer-direct-content">
            <determinant-manager
                *ngIf="serviceId && tmpAction"
                [serviceId]="serviceId"
                [determinantMapById]="determinantMapById"
                [jsonString]="tmpAction.jsonDeterminants"
                (builderUpdated)="temoupdateDeterminant($event)"
                [showBuilder]=true
                (cancel)="closeLayer()"
                (updateHeader)="showModalHeader($event)"
                class="d-flex overflow-hidden mh-100 h-100 w-100">
            </determinant-manager>
        </div>
    </drawer>
    
    <drawer [title]="'Apply bot'"
        [showHeader]="showDrawerHeader"
        [isClosed]="!showBotBuilder"
        (saveEvent)="saveActionComponent()"
        [noContentPadding]="!embedded"
        [embedded]="embedded"
        (closeEvent)="closeLayer();"
        [showHeaderButtons]="false"
        [contextLabel]="contextLabel"
        [noContentPadding]="true"
        class="text-left in-modal-drawer">
            <action-builder class="drawer-content d-flex flex-column"
            [serviceBots]="serviceBots"
            [tmpAction]="tmpAction"
            [stickyScrolling]="stickyScrolling"
            (updateAction)="updateBots($event)"
            (openNewModal)="openAddModal()"
            (openEditionModal)="directEditBot($event)"
            (deleteBot)="onDeleteBot($event)"
            (cancelEdition)="closeLayer()"
            (saveAction)="saveActionComponent();closeLayer()"></action-builder>
    </drawer>
<!--
<div class="row layer mt-0 in-tab-layer container-fluid" id="detFromFormio"
    [ngClass]="{'sub-layer-active': showDeterminantBuilder, 'hidden': !showDeterminantBuilder}" *ngIf="showDeterminantBuilder">
    <layer-header (closeLayer)="closeLayer()" (setListView)="setListView($event)" [listToggle]="listToggle"
        [listIcons]=false title="{{'Apply determinant' | translate}}" [customClass]="'mt-0'" *ngIf="store.state.common.determinantSection.topLayer !== 'edit'">
        <ng-content></ng-content>
    </layer-header>
    <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
        class="layer onTop-sub-layer" id="newDetFromFormio" [serviceId]="serviceId" [isOnSubLayer]="true"
        [determinant]="store.state.common.determinantSection.determinant" (formSubmit)="closeEdit()"
        (editCancel)="closeEdit()"></determinant-new>
    <div class="row {{store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''}}">
        <div class="col-12">
            <div class="row">
                <determinant-builder-new [serviceId]="serviceId" [jsonString]="tmpAction.jsonDeterminants"
                                         [determinantMapById]="determinantMapById"
                                         (onSave)="updateDeterminant($event);closeLayer()"
                                         (onChange)="tmpAction.jsonDeterminants = $event"
                                         (onCancel)="closeLayer()" class="col-12">
                </determinant-builder-new>
            </div>
        </div>
    </div>
</div>


<div *ngIf="!showBotAdd && !showBotEdit && showBotBuilder" id="botFromFormio" class="row layer mt-0 in-tab-layer container-fluid" [ngClass]="{'sub-layer-active': showBotBuilder, 'hidden': !showBotBuilder}">
    <layer-header (closeLayer)="closeLayer()" [listIcons]="false" [customClass]="'mt-0'" title="{{'Apply bot' | translate}}">
        <ng-content></ng-content>
    </layer-header>
    <div class="row">
        <div class="col">
           <action-builder
            [serviceBots]="serviceBots"
            [tmpAction]="tmpAction"
            [stickyScrolling]="stickyScrolling"
            (updateAction)="updateBots($event)"
            (openNewModal)="openAddModal()"
            (openEditionModal)="directEditBot($event)"
            (cancelEdition)="closeLayer()"
            (saveAction)="saveActionComponent();closeLayer()"></action-builder>
        </div>
    </div>
</div>
-->

<drawer [title]="'New bot'"
        [showHeader]="true"
        [isClosed]="!showBotAdd"
        [noContentPadding]="!embedded"
        [embedded]="embedded"
        (closeEvent)="closeAddEdit();"
        (saveEvent)="saveNewBot();"
        [contextLabel]="contextLabel"
        class="text-left in-modal-drawer">
        <div class="drawer-content drawer-direct-content">
            <role-bot-manage [serviceId]="serviceId" [showBotAdd]="showBotAdd" (modalAddedEvent)="addedBot()"></role-bot-manage>
        </div>
    </drawer>

<!--
    <app-new-bot #newBotComponent *ngIf="showBotAdd && showBotBuilder"
                class="on-iframe-form"
                id="newBotFromFormio"
                [fromTab]=true
                (modalClosedEvent)="closeAddEdit();"
                (modalAddedEvent)="addedBot();"></app-new-bot>
-->

    <drawer [title]="'Edit bot'"
        [showHeader]="true"
        [isClosed]="!showBotEdit"
        [noContentPadding]="!embedded"
        [embedded]="embedded"
        (closeEvent)="closeAddEdit();"
        (saveEvent)="saveEditBot();"
        (scrollEvent)="onEditBotDrawerScroll();"
        [contextLabel]="contextLabel"
        class="text-left in-modal-drawer">
        <div class="drawer-content drawer-direct-content" (scroll)="onEditBotDrawerScroll()">
            <app-edit-bot #editBotComponent *ngIf="showBotEdit && editBot"
                class="on-iframe-form"
                id="editBotFromFormio"
                (modalClosedEvent)="closeAddEdit();"
                (modalAddedEvent)="addedBot();"
                [activeTab]="(editBot.botType !== 'document' && editBot.botType !== 'message') ? 'bot-service' : 'general'"
                [bot]="editBot"></app-edit-bot>
        </div>
    </drawer>

<div class="fix-forms-bottom"></div>
